import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import { DRAWER_WIDTH } from '../layout/constants';

export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: DRAWER_WIDTH,
      maxWidth: DRAWER_WIDTH,
      backgroundColor: '#072098',
      backgroundImage: 'linear-gradient(180deg, #072098 0%, #0D3AAE 50%, #1565C0 100%)',
      color: '#fff',
      '& .MuiListItemIcon-root': {
        color: '#fff',
        minWidth: 'auto',
        marginRight: open ? '8px' : '0px',
        '& .MuiSvgIcon-root': {
          color: 'inherit',
        },
      },
      '& .MuiSvgIcon-root': {
        width: 20,
        height: 20,
        fontSize: 20,
        color: 'inherit',
      },
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: '60px',
        maxWidth: '60px',
        minWidth: '60px',
      }),
    },
  }),
);
